import * as Util from "../Utils/Util";
import Events from "../Utils/Events";
import ProductState from "./ProductState";

export class ProductQuantityHolder {
  private readonly element: HTMLElement;

  public constructor(element: HTMLElement) {
    this.element = element;
    Events.on("product-state-change", (s: ProductState) => this.updateText(s));
  }

  private updateText(s: ProductState): void {
    this.element.innerHTML = s.quantity.code + " " + s.quantity.unit + "s";
  }
}

export default function bindProductQuantityHolders(): void {
  const modals = Util.findByBindNameAll("product-quantity-holder");
  modals.forEach((s) => new ProductQuantityHolder(s as HTMLElement));
}
